import Typography from '@components/_atoms/Typography';
import { TypoVariant } from '@constants/atoms';
import styled from '@emotion/styled';
import { gray, primary } from '@styles/Colors';
import { useTranslation } from 'next-i18next';

const Layout = styled.div`
  padding: 16px 10px;
  border-bottom: 1px solid ${gray.gray4};

  display: grid;
  grid-template-columns: 80px 1fr 1fr 1fr 1fr;
  column-gap: 24px;
`;

type Props = {
  currency?: string;
};

export default function TableLabel({ currency }: Props) {
  const { t } = useTranslation('component');

  return (
    <Layout>
      <Typography variant={TypoVariant.SH3} color={primary.gray}>
        {t('totalCard.type')}
      </Typography>
      <Typography variant={TypoVariant.SH3} color={primary.gray}>
        {t('totalCard.quantity')}
        <br />
        <Typography variant={TypoVariant.B4}>{t('totalCard.quantity-description')}</Typography>
      </Typography>

      <Typography variant={TypoVariant.SH3} color={primary.gray}>
        {currency !== 'USD' && t('totalCard.supplyPrice')}
      </Typography>
      <Typography variant={TypoVariant.SH3} color={primary.gray}>
        {currency !== 'USD' && t('totalCard.vat')}
      </Typography>

      <Typography variant={TypoVariant.SH3} color={primary.gray}>
        {t('totalCard.totalPrice')}
      </Typography>
    </Layout>
  );
}
